module.exports = __webpack_public_path__ + "static/media/workingStrategies.fa97824a.PNG";